module.exports = __webpack_public_path__ + "img/Rectangle 1212-compressed.2eb4ec8c.jpg";